// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    addToChainAfter,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { addLineCollection } from "@insite/client-framework/Services/CartService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadQuote from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";

export const CheckForGroups: any = (props: any) => {
    // used in request quote and quote to add a new product to quote
    if (props.parameter.newGroup) {
        props.apiParameter = {
            ...props.apiParameter,
            cartLineCollection: {
                ...props.apiParameter.cartLineCollection,
                properties: {
                    groupName: props.parameter.groupName,
                },
            },
            // if on quote page, we have to pass the quote Id
            cartId: props.parameter.cartId ? props.parameter.cartId : API_URL_CURRENT_FRAGMENT,
        };
        // used in quote to add related products
    } else if (props.parameter.relatedProduct) {
        props.apiParameter = {
            ...props.apiParameter,
            cartLineCollection: {
                ...props.apiParameter.cartLineCollection,
                properties: {
                    isQuoteRelatedProducts: true,
                    quoteLineId: props.parameter.quoteLineId,
                    groupName: props.parameter.groupName,
                },
            },
            cartId: props.parameter.cartId,
        };
    }

    const isAuth = getSession(props.getState()).isAuthenticated;
    const postalCode = window.localStorage.getItem("postalCode") || "";
    const postalCodeId = window.localStorage.getItem("postalCodeID") || "";
    if (
        getSettingsCollection(props.getState()).customSettings &&
        (getSettingsCollection(props.getState()).customSettings as any).postalCodeLocationFinder.toLowerCase() ===
            "true" &&
        !isAuth &&
        postalCode &&
        postalCodeId
    ) {
        props.apiParameter.cartLineCollection = {
            ...props.apiParameter.cartLineCollection,
            properties: {
                validPostalCodeEntered: true,
            },
        };
    }
};

export const XngExecuteOnSuccessCallback: any = (props: any) => {
    if (props.parameter.loadCurrentCart) {
        props.dispatch(loadCurrentCart());
    }

    props.parameter.onSuccess?.(props.apiResult);
};

export const ReloadQuoteOnSuccess: any = (props: any) => {
    if (props.parameter.reloadQuote) {
        props.dispatch(loadQuote({ quoteId: props.parameter.cartId }));
    }
};

export const ExecuteOnComplete: any = (props: any) => {
    if (props.skipOnComplete) {
        return;
    }
    props.parameter.onComplete?.(props.apiResult);
};

export const CustomSendDataToApi: any = async (props: any) => {
    try {
        props.apiResult = await addLineCollection(props.apiParameter);
    } catch (error) {
        props.error = error.errorMessage;
    }
};

export const OnError: any = (props: any) => {
    if (props.error) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.error);
    }
};

addToChainAfter(chain, PopulateApiParameter, CheckForGroups);
replaceInChain(chain, SendDataToApi, CustomSendDataToApi);
replaceInChain(chain, ExecuteOnSuccessCallback, XngExecuteOnSuccessCallback);
addToChainAfter(chain, XngExecuteOnSuccessCallback, ReloadQuoteOnSuccess);
addToChainAfter(chain, ReloadQuoteOnSuccess, ExecuteOnComplete);
addToChainAfter(chain, XngExecuteOnSuccessCallback, OnError);
